import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Modal } from '@src/elements/modal/modal'
import { ExerciseResponse } from '@src/data/exercise-response'
import { MuscleMan } from '@src/pages/muscle-man/muscle-man'
import { Caption, H6, Subtitle2 } from '@src/elements/typography/typography'
import { getExerciseSteps } from '@src/util/functions'
import { exerciseName } from '@src/util/exercise-name'

import '@src/components/exercise-info/exercise-info.sass'

@Component
export class ExerciseInfoModal extends Vue {

  @Prop({ required: true })
  showModal: boolean

  @Prop({ required: true })
  exercise: ExerciseResponse

  @Prop({ required: false })
  closeCallback: () => void

  initialPositionSteps: string[] = []
  executionSteps: string[] = []
  healthLimitations: { allowed: string[], notAllowed: string[] } = { allowed: [], notAllowed: [] }

  constructor (props) {
    super(props)

    this.healthLimitations = this.exercise.getHealthLimitations(this.$store.state.exerciseTags['ExerciseTags::HealthLimitation'])
  }

  mounted () {
    getExerciseSteps(this, this.exercise.number, 'START', this.initialPositionSteps)
    getExerciseSteps(this, this.exercise.number, 'END', this.executionSteps)
  }

  render (h: CreateElement) {
    const initialPositionSteps = this.initialPositionSteps.map((key, index) => {
      return <div>
        <span class='index'><Subtitle2>{index + 1}</Subtitle2></span>
        <span class='info'><Subtitle2>{this.$t('EXERCISE[' + this.exercise.number + '].DESCRIPTION.START.' + key)}</Subtitle2></span>
      </div>
    })

    const executionSteps = this.executionSteps.map((key, index) => {
      return <div>
        <span class='index'><Subtitle2>{index + 1}</Subtitle2></span>
        <span class='info'><Subtitle2>{this.$t('EXERCISE[' + this.exercise.number + '].DESCRIPTION.END.' + key)}</Subtitle2></span>
      </div>
    })

    const allowedLimitations = this.healthLimitations.allowed.map(tag => {
      return <div><Caption>{this.$t(`PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.${tag.toUpperCase()}`)}</Caption></div>
    })

    const notAllowedLimitations = this.healthLimitations.notAllowed.map(tag => {
      return <div><Caption>{this.$t(`PAGE.CONTENT.WORKOUT.EXERCISE_TAGS.${tag.toUpperCase()}`)}</Caption></div>
    })

    const videoURLs = this.exercise.getVideoURLs()

    return <Modal title={exerciseName(this, this.exercise)} show={this.showModal} closeCallback={this.closeCallback} cssClass='exercise-info-modal'>
      <div class='info-img'>
        <video autoplay='autoplay' loop='loop' muted>
          <source src={videoURLs.webm} type='video/webm' />
          <source src={videoURLs.mp4} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>

      <div class='info-container'>
        {/* TODO integrate data when available */}
        {/*<div class='info-title'>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_INFO.EXERCISE_DESCRIPTION')}</div>*/}
        {/*<div class='info-content'>*/}
        {/*/!* TODO integrate data when available in PhraseApp -> Exercise Benefits *!/*/}
        {/*This workout is designed to really tax your lower body to get it ready for the*/}
        {/*strength section that comes next. If you want to get the most muscle building out of this workout then be*/}
        {/*sure to push yourself as hard as you can on every repetition of the HIIT exercises. That means 100% effort*/}
        {/*and as full of a range of motion that you can control.*/}
        {/*</div>*/}

        {initialPositionSteps.length > 0 ?
          <div>
            <H6 class='info-title'>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_INFO.INITIAL_POSITION')}</H6>
            <div class='list-content'>
              {initialPositionSteps}
            </div>
          </div>
          : null}

        <H6 class='info-title'>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_INFO.EXECUTION')}</H6>
        <div class='list-content'>

          {executionSteps}

          <div class='muscles'>
            <MuscleMan facing='front' primaryMuscles={this.exercise.primaryMuscles} secondaryMuscles={this.exercise.secondaryMuscles} />
            <MuscleMan facing='back' primaryMuscles={this.exercise.primaryMuscles} secondaryMuscles={this.exercise.secondaryMuscles} />
          </div>
        </div>

        {/* TODO integrate data when available */}
        {/*<div class='info-title'>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_INFO.BENEFITS')}</div>*/}
        {/*<div class='benefits' style={'height:' + 8 * 23 + 'px'}>*/}
        {/*<div class='description'><span class='index'>1</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>2</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>3</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>4</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>5</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>6</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>7</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*<div><span class='index'>8</span><span class='info'> Keep the elbow joints slightly bent</span></div>*/}
        {/*</div>*/}

        <div class='info-title'><H6>{this.$t('HEALTH_LIMITATIONS')}</H6></div>
        <div class='limitations'>
          <div class='not-allowed'>
            <div class='description'><Subtitle2>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_INFO.NOT_ALLOWED')}</Subtitle2></div>
          </div>
          <div class='allowed'>
            <div class='description'><Subtitle2>{this.$t('PAGE.CONTENT.WORKOUT.EXERCISE_INFO.ALLOWED')}</Subtitle2></div>
          </div>
        </div>
        <div class='limitations'>
          <div class='not-allowed'>
            <div class='list'>
              {notAllowedLimitations}
            </div>
          </div>
          <div class='allowed'>
            <div class='list'>
              {allowedLimitations}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  }
}
